import React from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import {useTranslation} from "react-i18next";

import useVonAuthentication from '../../Hooks/useVonAuthentication';
import commonActionsImp from '../../Actions/commonActions';

import './VonAuthorization.css';

const VonAuthorization = ({ onCancel, redirectUrl, children, inModal = false }) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const isSignedIn = useVonAuthentication();

    const commonActions = bindActionCreators(commonActionsImp, dispatch);

    if (!isSignedIn) {
        // In a modal the prompt must stay in-flow so the dialog gets its height from
        // content + padding. Absolute centering (used on pages with a relative,
        // min-height parent) would collapse the flex-column dialog to a thin strip.
        const promptClass = inModal
            ? 'von-authorization-prompt von-authorization-prompt--modal text-center'
            : 'von-authorization-prompt position-absolute-center text-center';

        return (
            <div className={promptClass}>
                <div className="auth-content">
                    <p>{t('vonAuthorization.message')}</p>

                    <div className="d-flex gap-8 align-items-center justify-content-center flex-wrap">
                        <button className="btn btn-primary btn-sm" onClick={() => commonActions.signInToVon(redirectUrl)}>
                            {t('vonAuthorization.confirmAction')}
                        </button>

                        {onCancel && (
                            <button className="btn btn-default btn-sm" onClick={onCancel}>
                                {t('vonAuthorization.cancelAction')}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return <>{children}</>;
};

export default VonAuthorization;
